import { render, staticRenderFns } from "./AccountDeletionRequestForm.vue?vue&type=template&id=ec75b346&"
import script from "./AccountDeletionRequestForm.vue?vue&type=script&lang=ts&"
export * from "./AccountDeletionRequestForm.vue?vue&type=script&lang=ts&"
import style0 from "./AccountDeletionRequestForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports